<script>

export const requireAuth = false;
export const pageName = 'account-sign-in';
export const pageRoute = '/account/sign-in';
export const title = 'Sign-in'

import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword, fetchSignInMethodsForEmail, linkWithCredential } from 'firebase/auth'
import { validation } from '../../js/language.js'
import { getAdditionalUserInfo } from 'firebase/auth'
import { showToast } from '../../js/utils/toast.js';
import { navigate, PageShowError } from '@trullock/page-manager';
import { commands } from '../../js/lib/functions.js'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { userChanged } from '../../js/auth.js';

export default {
	data() {
		return {
			email: '',
			password: ''
		 }
	},
	methods: {
		resetAuthErrors: function(){
			this.$refs.btnGoogle.classList.remove('glow');
			this.$refs.password.classList.remove('glow');
		},
		resetPassword: function(e){
			e.stopPropagation();
			navigate(e.target.getAttribute('href'), { email: this.email })
		},
		submit: async function() {
			this.resetAuthErrors();

			this.$refs.email.setCustomValidity('');
			this.$refs.password.setCustomValidity('');
			showLoading();

			try
			{
				let userChangedP = userChanged();

				let signInResult = await signInWithEmailAndPassword(getAuth(), this.email, this.password)

				await userChangedP;

				navigate('goal');

				if(this.pendingCred)
				{
					signInResult.user.linkWithCredential(this.pendingCred).then(result => {
						showToast({
							style: 'bg-success',
							message: this.pendingCredLinkedMessage
						})
					}, e => console.error(e));
				}
			}
			catch(error)
			{
				if(error.code == 'auth/wrong-password')
				{
					return fetchSignInMethodsForEmail(getAuth(), this.email).then(methods => {
						if(methods.indexOf('password') == -1)
						{
							this.glowAuthProviderMethods(methods);
							this.$refs.email.setCustomValidity(validation['auth/no-password']);
							this.$refs.email.reportValidity();
						}
						else
						{
							this.$refs.password.setCustomValidity(validation[error.code] || validation['error']);
							this.$refs.password.reportValidity();
						}

						hideLoading();
					});
				}
				
				this.$refs.email.setCustomValidity(validation[error.code] || validation['error']);
				this.$refs.email.reportValidity();			
			}

			hideLoading();
		},
		ssoGoogle: function() {
			var provider = new GoogleAuthProvider();
			this.signInWithSSO(provider, 'Account successfully linked to your Google account');
		},
		signInWithSSO: async function(provider, linkedMessage){
			this.resetAuthErrors();
			this.$refs.form.reset(); // to prevent chrome suggesting to save unused details in the form
			
			showLoading('Waiting for response from authentication popup...');

			// filter null because initially it "changes" to null as the listener starts looking for the new user that doesnt exist yet
			let userChangedP = userChanged(u => !!u);

			commands.warmUp();

			try
			{
				let signInResult = await signInWithPopup(getAuth(), provider)
				
				let info = getAdditionalUserInfo(signInResult);
				if(info.isNewUser)
				{
					showLoading('Creating account...');

					let result = await commands.users.account.create({ name: signInResult.user.displayName })
					if(!result.success)
					{
						await signInResult.user.delete();

						hideLoading();
						showToast({ message: 'Error creating your account', style: 'bg-danger'})
						return;
					}

					// refresh token for new users
					await signInResult.user.getIdToken(true);
				}
				else
				{
					showLoading('Logging you in...');
					
					// TODO: this is hacky, can we just do this in the backend when necessary?
					await commands.users.account.updateEmailVerified();
				}

				await userChangedP;
				hideLoading();

				navigate('goal', { fallback: info.isNewUser ? '/account/complete' : '/'});

				if(this.pendingCred)
				{
					linkWithCredential(signInResult.user, this.pendingCred).then(result => {
						showToast({
							style: 'bg-success',
							message: this.pendingCredLinkedMessage
						})
					}, e => console.error(e));
				}
			}
			catch (error)
			{
				if(error.code == 'auth/account-exists-with-different-credential')
				{
					this.handleExistingAuth(error, linkedMessage);
					return;
				}

				console.error(error);

				this.$refs.email.setCustomValidity(validation[error.code] || validation['error']);
				this.$refs.email.reportValidity();
				
				hideLoading();
			}
			
		},
		handleExistingAuth: function(error, linkedMessage){
			this.pendingCred = error.credential;
			this.pendingCredLinkedMessage = linkedMessage
			this.email = error.email;

			fetchSignInMethodsForEmail(getAuth(), error.email).then(methods => {
				this.glowAuthProviderMethods(methods);
			});

			this.$refs.email.setCustomValidity(validation[error.code] || validation['error']);
			this.$refs.email.reportValidity();
		},
		glowAuthProviderMethods: function(methods) {
			if(methods.indexOf('google.com') > -1)
				this.$refs.btnGoogle.classList.add('glow');
			if(methods.indexOf('password') > -1)
				this.$refs.password.classList.add('glow');
		},
		show: function(opts) {
			if(getAuth().currentUser)
				throw new PageShowError('/', 'Already signed in', {}, 'replace')

			commands.warmUp();

			this.resetAuthErrors();
			this.pendingCred = null;
			this.pendingCredLinkedMessage = null;
			this.$refs.form.reset();
		}
	}
}

</script>
<template>
<div class="container">
	<div class="row justify-content-center">
		<div class="col-12 col-md-6 my-5">
			<h1 class="display-4 text-center mb-3">Sign in</h1>
			<p class="text-muted text-center mb-5">Welcome back.</p>
			<div class="text-center mb-4">
				<button @click.prevent="ssoGoogle" ref="btnGoogle" class="btn btn-white btn-auth"><img alt="Google icon" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" width="18" height="18"> Sign in with Google</button>
			</div>
			<p>I agree to the <a href="/terms-of-service" target="_blank">terms of service <span class="fe fe-external-link"></span></a> and <a href="/privacy-policy" target="_blank">privacy policy <span class="fe fe-external-link"></span></a></p>
			<hr class="mb-4" />
			<form @submit.prevent="submit" ref="form">
				<fieldset class="mb-4">
					<legend>Login credentials</legend>
					<div class="form-group mb-4">
						<label>Email</label>
						<input type="email" class="form-control" ref="email" v-model="email" autocomplete="email" placeholder="e.g. your.name@example.com" required tabindex="1" />
						<span class="invalid-feedback"></span>
					</div>
					<div class="form-group mb-4">
						<label>Password</label>
						<div class="input-group has-validation">
							<input type="password" ref="password" v-model="password" placeholder="Your password" class="form-control form-control-appended" autocomplete="current-password" required minlength="8" tabindex="3">
							<div class="input-group-append">
								<button class="btn btn-outline-secondary js-reveal" tabindex="-1" type="button"><span class="fe fe-eye"></span><span class="sr-only">Show/Hide password</span></button>
							</div>
							<span class="invalid-feedback"></span>
						</div>
					</div>
				</fieldset>
				<button type="submit" ref="btnSignIn" class="btn btn-lg btn-block btn-primary mb-3">Sign In</button>
				<div class="text-center">
					<p class="small text-muted mb-2"><a href="/account/reset-password" @click.prevent="resetPassword">Reset your password</a> if you've forgotten it.</p>
					<p class="small text-muted">Not got an account yet? <a href="/account/sign-up">Sign up</a> now.</p>
				</div>
			</form>
		</div>
	</div>
</div>
</template>